import ReactDOM from 'react-dom/client';
import App from './App';
import ReactGA from 'react-ga';
import { startAuthSession } from 'store/authSession';

// 저장 상태 오류에서도 실행되도록 React 밖에서 시작한다.
startAuthSession();

const TRACKING_ID: any = process.env.REACT_APP_GOOGLE_ANALYTICS_TRACKING_ID; // 발급받은 추적ID를 환경 변수로 불러온다.
ReactGA.initialize(TRACKING_ID);

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(<App />);
